import { Badge } from "antd";

import useUnread from "../useUnread";
import styles from "./notices-count-badge.module.css";

/**
 * Число непрочитанных уведомлений на значке в подвале меню.
 * Пока число не загружено — прежняя точка (fallbackDot).
 */
export default function NoticesCountBadge({ fallbackDot = false, children }) {
  const { notices } = useUnread();

  if (notices.count === null) {
    return (
      <Badge dot={fallbackDot} color="#E66A25" className={styles.dot}>
        {children}
      </Badge>
    );
  }

  return (
    <Badge
      count={notices.count}
      overflowCount={99}
      size="small"
      color="#E66A25"
      className={styles.count}
    >
      {children}
    </Badge>
  );
}
